import React, { useState } from "react";

const S = {
  wrapper: { marginTop:'10px', marginLeft:'0px', border:'3px', padding:'40px', borderStyle:'solid', borderColor:'grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Right Triangle Anatomy + All Six Ratios
// ─────────────────────────────────────────────────────────────────
function DiagramRightTriangle() {
  const W = 900, H = 280;
  // Triangle vertices: right angle at C(80,220), B(450,220), A(80,55)
  const C = [90, 225], B = [450, 225], A = [90, 55];
  const adj = B[0]-C[0], opp = C[1]-A[1], hyp = Math.sqrt(adj*adj+opp*opp);
  const theta = Math.atan2(opp, adj);
  const deg = (theta*180/Math.PI).toFixed(1);

  // right angle box at C
  const rSize = 14;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Right Triangle Anatomy — All Six Trigonometric Ratios</div>
        <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>
          {/* Triangle fill */}
          <polygon points={C.join(',')+' '+B.join(',')+' '+A.join(',')} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2.5"/>
          {/* Right angle box */}
          <polyline points={(C[0]+rSize)+","+C[1]+" "+(C[0]+rSize)+","+(C[1]-rSize)+" "+C[0]+","+(C[1]-rSize)} fill="none" stroke="#1F3864" strokeWidth="1.5"/>

          {/* Side labels */}
          {/* Adjacent (bottom) */}
          <rect x={(C[0]+B[0])/2-28} y={B[1]+8} width={56} height={18} rx={3} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="1"/>
          <text x={(C[0]+B[0])/2} y={B[1]+21} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">adjacent</text>
          {/* Opposite (left side) */}
          <rect x={A[0]-72} y={(A[1]+C[1])/2-9} width={68} height={18} rx={3} fill="#fff0f0" stroke="#c0392b" strokeWidth="1"/>
          <text x={A[0]-38} y={(A[1]+C[1])/2+5} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">opposite</text>
          {/* Hypotenuse (diagonal) */}
          {(() => {
            const mx=(A[0]+B[0])/2, my=(A[1]+B[1])/2;
            const nx=-(B[1]-A[1])/hyp, ny=(B[0]-A[0])/hyp;
            return (
              <g>
                <rect x={mx+nx*14-40} y={my+ny*14-9} width={80} height={18} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
                <text x={mx+nx*14} y={my+ny*14+5} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">hypotenuse</text>
              </g>
            );
          })()}

          {/* Angle theta arc at B */}
          {(() => {
            const r=38;
            const ang=Math.atan2(A[1]-B[1], A[0]-B[0]);
            const x1=B[0]+r*Math.cos(0), y1=B[1]+r*Math.sin(0);
            const x2=B[0]+r*Math.cos(ang), y2=B[1]+r*Math.sin(ang);
            return (
              <g>
                <path d={"M "+x1+","+y1+" A "+r+" "+r+" 0 0 1 "+x2+","+y2} fill="none" stroke="#e07b00" strokeWidth="2"/>
                <text x={B[0]-55} y={B[1]-18} fontSize="13" fill="#e07b00" fontWeight="700">θ = {deg}°</text>
              </g>
            );
          })()}

          {/* Vertex labels */}
          <text x={A[0]-14} y={A[1]-6} fontSize="13" fill="#1F3864" fontWeight="700">A</text>
          <text x={B[0]+6}  y={B[1]+16} fontSize="13" fill="#1F3864" fontWeight="700">B</text>
          <text x={C[0]-16} y={C[1]+16} fontSize="13" fill="#1F3864" fontWeight="700">C</text>

          {/* Numeric values */}
          <text x={(C[0]+B[0])/2} y={B[1]+42} textAnchor="middle" fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">= {adj}</text>
          <text x={A[0]-38} y={(A[1]+C[1])/2+22} textAnchor="middle" fontSize="10" fill="#c0392b" fontFamily="'Courier New',monospace">= {opp}</text>
          <text x={(A[0]+B[0])/2+30} y={(A[1]+B[1])/2+4} fontSize="10" fill="#27ae60" fontFamily="'Courier New',monospace">= {hyp.toFixed(1)}</text>

          {/* Six ratios panel */}
          <rect x={560} y={10} width={200} height={258} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={660} y={30} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Six Trig Ratios</text>
          {[
            ['sin θ','opp/hyp','#c0392b'],
            ['cos θ','adj/hyp','#2E75B6'],
            ['tan θ','opp/adj','#e07b00'],
            ['csc θ','hyp/opp','#c0392b'],
            ['sec θ','hyp/adj','#2E75B6'],
            ['cot θ','adj/opp','#e07b00'],
          ].map(([name,ratio,col],i) => (
            <g key={i}>
              <text x={575} y={52+i*36} fontSize="13" fill={col} fontWeight="700" fontFamily="'Courier New',monospace">{name}</text>
              <text x={575} y={66+i*36} fontSize="12"  fill="#555" fontFamily="'Courier New',monospace">{ratio}</text>
            </g>
          ))}

          {/* Pythagorean */}
          <rect x={490} y={10} width={58} height={258} rx={0} fill="none"/>
          <rect x={200} y={10} width={340} height={38} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.2"/>
          <text x={370} y={26} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Pythagorean Theorem:</text>
          <text x={370} y={42} textAnchor="middle" fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">adj² + opp² = hyp²  →  {adj}² + {opp}² = {(hyp*hyp).toFixed(0)}</text>
        </svg>
      <div style={S.dCaption}>
        Every trig ratio is just a ratio of two sides of a right triangle. The three primary ratios (sin, cos, tan) each have a reciprocal (csc, sec, cot). The angle and all ratios are fully determined once you know any two sides.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Unit Circle
// ─────────────────────────────────────────────────────────────────
function DiagramUnitCircle() {
  const W = 700, H = 700, cx = 350, cy = 350, R = 270;
  const toX = (r, t) => cx + r*Math.cos(t);
  const toY = (r, t) => cy - r*Math.sin(t);
  const deg = d => d*Math.PI/180;

  const angles = [
    {d:0,   label:'0',       rad:'0',        coord:'(1, 0)'},
    {d:30,  label:'30°',     rad:'π/6',      coord:'(√3/2, 1/2)'},
    {d:45,  label:'45°',     rad:'π/4',      coord:'(√2/2, √2/2)'},
    {d:60,  label:'60°',     rad:'π/3',      coord:'(1/2, √3/2)'},
    {d:90,  label:'90°',     rad:'π/2',      coord:'(0, 1)'},
    {d:120, label:'120°',    rad:'2π/3',     coord:'(-1/2, √3/2)'},
    {d:135, label:'135°',    rad:'3π/4',     coord:'(-√2/2, √2/2)'},
    {d:150, label:'150°',    rad:'5π/6',     coord:'(-√3/2, 1/2)'},
    {d:180, label:'180°',    rad:'π',        coord:'(-1, 0)'},
    {d:210, label:'210°',    rad:'7π/6',     coord:'(-√3/2, -1/2)'},
    {d:225, label:'225°',    rad:'5π/4',     coord:'(-√2/2, -√2/2)'},
    {d:240, label:'240°',    rad:'4π/3',     coord:'(-1/2, -√3/2)'},
    {d:270, label:'270°',    rad:'3π/2',     coord:'(0, -1)'},
    {d:300, label:'300°',    rad:'5π/3',     coord:'(1/2, -√3/2)'},
    {d:315, label:'315°',    rad:'7π/4',     coord:'(√2/2, -√2/2)'},
    {d:330, label:'330°',    rad:'11π/6',    coord:'(√3/2, -1/2)'},
  ];

  const qColors = ['#EBF3FB','#fff0f0','#f0fff4','#fff7ee'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Unit Circle — All 16 Standard Angles with Radian and Coordinate Labels</div>
        <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>
          {/* Quadrant shading */}
          <path d={"M "+cx+","+cy+" L "+(cx+R)+","+cy+" A "+R+" "+R+" 0 0 0 "+cx+","+(cy-R)+" Z"} fill={qColors[0]} opacity="0.5"/>
          <path d={"M "+cx+","+cy+" L "+cx+","+(cy-R)+" A "+R+" "+R+" 0 0 0 "+(cx-R)+","+cy+" Z"} fill={qColors[1]} opacity="0.5"/>
          <path d={"M "+cx+","+cy+" L "+(cx-R)+","+cy+" A "+R+" "+R+" 0 0 0 "+cx+","+(cy+R)+" Z"} fill={qColors[2]} opacity="0.5"/>
          <path d={"M "+cx+","+cy+" L "+cx+","+(cy+R)+" A "+R+" "+R+" 0 0 0 "+(cx+R)+","+cy+" Z"} fill={qColors[3]} opacity="0.5"/>

          {/* Quadrant signs */}
          {[{x:cx+R*0.5,y:cy-R*0.5,sin:'+',cos:'+'},{x:cx-R*0.5,y:cy-R*0.5,sin:'+',cos:'-'},{x:cx-R*0.5,y:cy+R*0.5,sin:'-',cos:'-'},{x:cx+R*0.5,y:cy+R*0.5,sin:'-',cos:'+'}].map(({x,y,sin,cos},i)=>(
            <g key={i}>
              <text x={x} y={y-6} textAnchor="middle" fontSize="11" fill="#888">sin {sin}</text>
              <text x={x} y={y+8} textAnchor="middle" fontSize="11" fill="#888">cos {cos}</text>
            </g>
          ))}

          {/* Axes */}
          <line x1={cx-R-30} y1={cy} x2={cx+R+30} y2={cy} stroke="#1F3864" strokeWidth="1.5"/>
          <line x1={cx} y1={cy+R+30} x2={cx} y2={cy-R-30} stroke="#1F3864" strokeWidth="1.5"/>
          <text x={cx+R+34} y={cy+4}  fontSize="12" fill="#1F3864" fontWeight="700">x</text>
          <text x={cx+4}    y={cy-R-32} fontSize="12" fill="#1F3864" fontWeight="700">y</text>

          {/* Unit circle */}
          <circle cx={cx} cy={cy} r={R} fill="none" stroke="#2E75B6" strokeWidth="2"/>

          {/* Radial lines + points + labels */}
          {angles.map(({d,label,rad,coord},i) => {
            const t = deg(d);
            const px = toX(R,t), py = toY(R,t);
            const lx = toX(R+40,t), ly = toY(R+40,t);
            // Nudge labels for crowding
            const offsets = {0:[8,0],30:[4,-8],45:[4,-6],60:[0,-8],90:[0,-10],120:[-4,-8],135:[-6,-6],150:[-8,-8],180:[-10,0],210:[-8,8],225:[-6,6],240:[-4,8],270:[0,10],300:[4,8],315:[6,6],330:[8,4]};
            const [ox2,oy2] = offsets[d]||[0,0];
            return (
              <g key={i}>
                <line x1={cx} y1={cy} x2={px} y2={py} stroke="#ccd9ea" strokeWidth="1"/>
                <circle cx={px} cy={py} r={5} fill="#2E75B6" stroke="#fff" strokeWidth="1.2"/>
                <text x={lx+ox2} y={ly+oy2-8} textAnchor="middle" fontSize="11" fill="#e07b00" fontWeight="700">{label}</text>
                <text x={lx+ox2} y={ly+oy2+5} textAnchor="middle" fontSize="11" fill="#555">{rad}</text>
                <text x={lx+ox2} y={ly+oy2+18} textAnchor="middle" fontSize="10" fill="#2E75B6">{coord}</text>
              </g>
            );
          })}

          {/* Origin */}
          <circle cx={cx} cy={cy} r={4} fill="#1F3864"/>
          <text x={cx+6} y={cy+14} fontSize="11" fill="#1F3864" fontWeight="700">O</text>

          {/* r=1 label */}
          <text x={cx+R*0.5+4} y={cy-R*0.5-4} fontSize="13" fill="#2E75B6" fontWeight="700">r = 1</text>
        </svg>
      <div style={S.dCaption}>
        The unit circle has radius 1 centered at the origin. Any point on it is (cos θ, sin θ). This is the definition of sine and cosine for all angles — not just acute ones in right triangles.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 3 — SOH-CAH-TOA with Numeric Example
// ─────────────────────────────────────────────────────────────────
function DiagramSOHCAHTOA() {
  const W = 900, H = 300;

  // Triangle: right angle C, angle at B
  const C = [90, 240], B = [390, 240], A = [90, 60];
  const adj=B[0]-C[0], opp=C[1]-A[1], hyp=Math.sqrt(adj*adj+opp*opp);
  const theta = Math.atan2(opp,adj)*180/Math.PI;

  const cards = [
    { name:'SOH', full:'Sine = Opposite / Hypotenuse', formula:'sin θ = opp/hyp', num:'sin('+theta.toFixed(1)+'°) = '+opp+'/'+hyp.toFixed(1)+' = '+(opp/hyp).toFixed(3), color:'#c0392b', fill:'#fff0f0', use:'Vertical component of a force' },
    { name:'CAH', full:'Cosine = Adjacent / Hypotenuse', formula:'cos θ = adj/hyp', num:'cos('+theta.toFixed(1)+'°) = '+adj+'/'+hyp.toFixed(1)+' = '+(adj/hyp).toFixed(3), color:'#2E75B6', fill:'#EBF3FB', use:'Horizontal component of a force' },
    { name:'TOA', full:'Tangent = Opposite / Adjacent', formula:'tan θ = opp/adj', num:'tan('+theta.toFixed(1)+'°) = '+opp+'/'+adj+' = '+(opp/adj).toFixed(3), color:'#e07b00', fill:'#fff7ee', use:'Slope and angle of inclination' },
  ];

  const panelX = 430, panW = (W - panelX - 20) / 3;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>SOH-CAH-TOA — The Three Primary Ratios with Numeric Examples</div>
      <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>
        {/* Triangle */}
        <polygon points={C.join(',')+' '+B.join(',')+' '+A.join(',')} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2.5"/>
        <polyline points={(C[0]+14)+","+C[1]+" "+(C[0]+14)+","+(C[1]-14)+" "+C[0]+","+(C[1]-14)} fill="none" stroke="#1F3864" strokeWidth="1.5"/>
        {(() => {
          const r=44, t=Math.atan2(A[1]-B[1],A[0]-B[0]);
          const x1=B[0]+r, y1=B[1];
          const x2=B[0]+r*Math.cos(t), y2=B[1]+r*Math.sin(t);
          return <path d={"M "+x1+","+y1+" A "+r+" "+r+" 0 0 1 "+x2+","+y2} fill="none" stroke="#e07b00" strokeWidth="2"/>;
        })()}
        <text x={B[0]-70} y={B[1]-18} fontSize="14" fill="#e07b00" fontWeight="700">{"θ = "+theta.toFixed(1)+"°"}</text>
        {/* Side annotations */}
        <rect x={(C[0]+B[0])/2-48} y={C[1]+8} width={96} height={18} rx={3} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={(C[0]+B[0])/2} y={C[1]+21} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">adjacent = {adj}</text>
        <rect x={A[0]-80} y={(A[1]+C[1])/2-9} width={76} height={18} rx={3} fill="#fff0f0" stroke="#c0392b" strokeWidth="1"/>
        <text x={A[0]-42} y={(A[1]+C[1])/2+5} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">opp = {opp}</text>
        {(() => {
          const mx=(A[0]+B[0])/2, my=(A[1]+B[1])/2;
          return <text x={mx+22} y={my-4} fontSize="12" fill="#27ae60" fontWeight="700">hyp = {hyp.toFixed(0)}</text>;
        })()}
        {/* Vertex labels */}
        <text x={A[0]-16} y={A[1]-8} fontSize="14" fill="#1F3864" fontWeight="700">A</text>
        <text x={B[0]+8} y={B[1]+18} fontSize="14" fill="#1F3864" fontWeight="700">B</text>
        <text x={C[0]-18} y={C[1]+18} fontSize="14" fill="#1F3864" fontWeight="700">C</text>

        {/* SOH/CAH/TOA cards as SVG panels */}
        {cards.map(({name,full,formula,num,color,fill,use},i) => {
          const px = panelX + i*(panW+8), py = 10;
          return (
            <g key={name}>
              <rect x={px} y={py} width={panW} height={H-20} rx={6} fill={fill} stroke={color} strokeWidth="2"/>
              <rect x={px+6} y={py+6} width={panW-12} height={28} rx={4} fill={color}/>
              <text x={px+panW/2} y={py+25} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700" fontFamily="'Courier New',monospace">{name}</text>
              <text x={px+panW/2} y={py+56} textAnchor="middle" fontSize="11" fill="#444">{full}</text>
              <text x={px+panW/2} y={py+82} textAnchor="middle" fontSize="13" fill={color} fontWeight="700" fontFamily="'Courier New',monospace">{formula}</text>
              <text x={px+panW/2} y={py+108} textAnchor="middle" fontSize="10" fill="#444" fontFamily="'Courier New',monospace">{num}</text>
              <line x1={px+12} y1={py+118} x2={px+panW-12} y2={py+118} stroke="#ddd" strokeWidth="1"/>
              <text x={px+panW/2} y={py+134} textAnchor="middle" fontSize="10" fill="#666" fontStyle="italic">ME: {use}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        SOH-CAH-TOA is the mnemonic for the three primary ratios. In force analysis: the component along an axis = force magnitude × cosine of the angle to that axis. The perpendicular component uses sine.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Trig Graphs (sin, cos, tan)
// ─────────────────────────────────────────────────────────────────
function DiagramTrigGraphs() {
  const W = 900, H = 310, ox = 70, oy = 155, sc = 88;
  const toX = t => ox + t * sc;
  const toY = y => oy - y * sc;

  function makePts(fn, t0, t1, step, H) {
    const segs=[], cur=[];
    for(let t=t0;t<=t1;t+=step){
      const y=fn(t), sy=toY(y);
      if(!isFinite(y)||sy<5||sy>H-5){ if(cur.length>1)segs.push('M '+cur.join(' L ')); cur.length=0; }
      else cur.push(toX(t).toFixed(1)+','+sy.toFixed(1));
    }
    if(cur.length>1)segs.push('M '+cur.join(' L '));
    return segs.join(' ');
  }

  const sinPath = makePts(t=>Math.sin(t), -0.5, 2*Math.PI+0.5, 0.03, H);
  const cosPath = makePts(t=>Math.cos(t), -0.5, 2*Math.PI+0.5, 0.03, H);
  const tanPath = makePts(t=>{const v=Math.tan(t);return Math.abs(v)>4?NaN:v;}, -0.5, 2*Math.PI+0.5, 0.02, H);

  const piTicks = [[0,'0'],[Math.PI/2,'π/2'],[Math.PI,'π'],[3*Math.PI/2,'3π/2'],[2*Math.PI,'2π']];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Trig Graphs — sin x, cos x, and tan x Over One Full Period</div>
        <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>
          {/* Amplitude lines */}
          <line x1={ox-10} y1={toY(1)}  x2={toX(2*Math.PI+0.5)} y2={toY(1)}  stroke="#eee" strokeWidth="1"/>
          <line x1={ox-10} y1={toY(-1)} x2={toX(2*Math.PI+0.5)} y2={toY(-1)} stroke="#eee" strokeWidth="1"/>
          <text x={ox-12} y={toY(1)+4}  textAnchor="end" fontSize="10" fill="#bbb">1</text>
          <text x={ox-12} y={toY(-1)+4} textAnchor="end" fontSize="10" fill="#bbb">-1</text>

          {/* Vertical asymptote guide for tan */}
          {[Math.PI/2, 3*Math.PI/2].map((t,i) => (
            <line key={i} x1={toX(t)} y1={10} x2={toX(t)} y2={H-10} stroke="#e07b00" strokeWidth="1" strokeDasharray="4,4" opacity="0.5"/>
          ))}

          {/* Axes */}
          <line x1={ox-10} y1={oy} x2={toX(2*Math.PI+0.5)} y2={oy} stroke="#1F3864" strokeWidth="1.5"/>
          <line x1={ox}    y1={H-10} x2={ox} y2={10} stroke="#1F3864" strokeWidth="1.5"/>
          <text x={toX(2*Math.PI+0.5)+4} y={oy+4} fontSize="11" fill="#1F3864" fontWeight="700">θ</text>
          <text x={ox+4} y={12} fontSize="11" fill="#1F3864" fontWeight="700">y</text>

          {/* Pi ticks */}
          {piTicks.map(([t,lbl]) => (
            <g key={lbl}>
              <line x1={toX(t)} y1={oy-4} x2={toX(t)} y2={oy+4} stroke="#1F3864" strokeWidth="1.5"/>
              <text x={toX(t)} y={oy+16} textAnchor="middle" fontSize="10" fill="#555">{lbl}</text>
            </g>
          ))}

          {/* Curves */}
          <path d={sinPath} fill="none" stroke="#2E75B6" strokeWidth="2.4"/>
          <path d={cosPath} fill="none" stroke="#c0392b" strokeWidth="2.4"/>
          <path d={tanPath} fill="none" stroke="#e07b00" strokeWidth="1.8" strokeDasharray="6,2"/>

          {/* Period brace for sin */}
          {(() => {
            const y0 = H-22;
            return (
              <g>
                <line x1={toX(0)} y1={y0} x2={toX(2*Math.PI)} y2={y0} stroke="#2E75B6" strokeWidth="1.5"/>
                <line x1={toX(0)} y1={y0-5} x2={toX(0)} y2={y0+5} stroke="#2E75B6" strokeWidth="1.5"/>
                <line x1={toX(2*Math.PI)} y1={y0-5} x2={toX(2*Math.PI)} y2={y0+5} stroke="#2E75B6" strokeWidth="1.5"/>
                <text x={toX(Math.PI)} y={y0-5} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">period = 2π</text>
              </g>
            );
          })()}

          {/* Legend */}
          <rect x={W-200} y={12} width={188} height={90} rx={5} fill="#fff" stroke="#ccd9ea"/>
          {[['sin x','#2E75B6','period 2π, amp 1'],['cos x','#c0392b','period 2π, amp 1'],['tan x','#e07b00','period π, no amp']].map(([lbl,col,note],i)=>(
            <g key={i}>
              <line x1={W-192} y1={32+i*26} x2={W-166} y2={32+i*26} stroke={col} strokeWidth={i===2?2:2.8} strokeDasharray={i===2?'4,2':''}/>
              <text x={W-160} y={36+i*26} fontSize="12" fill={col} fontWeight="700" fontFamily="'Courier New',monospace">{lbl}</text>
              <text x={W-160} y={49+i*26} fontSize="10" fill="#888">{note}</text>
            </g>
          ))}

          {/* Asymptote note */}
          <text x={toX(Math.PI/2)-2} y={28} textAnchor="middle" fontSize="11" fill="#e07b00">VA</text>
          <text x={toX(3*Math.PI/2)-2} y={28} textAnchor="middle" fontSize="11" fill="#e07b00">VA</text>
        </svg>
      <div style={S.dCaption}>
        Sin and cos repeat every 2π (360°) with amplitude 1. Tan repeats every π (180°) and shoots to ±∞ at odd multiples of π/2 where cos = 0. The general form y = A·sin(Bx + C) + D lets you scale, shift, and offset any of these.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 5 — Pythagorean Identity Family
// ─────────────────────────────────────────────────────────────────
function DiagramIdentities() {
  const W = 900, H = 300, cx = 170, cy = 160, R = 120;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pythagorean Identities — Visual Proof and the Full Identity Family Tree</div>
        <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>
          {/* Unit circle proof */}
          <circle cx={cx} cy={cy} r={R} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2"/>
          <line x1={cx-R-14} y1={cy} x2={cx+R+14} y2={cy} stroke="#1F3864" strokeWidth="1.3"/>
          <line x1={cx} y1={cy+R+14} x2={cx} y2={cy-R-14} stroke="#1F3864" strokeWidth="1.3"/>

          {/* Sample angle 53deg */}
          {(() => {
            const t=53*Math.PI/180;
            const px=cx+R*Math.cos(t), py=cy-R*Math.sin(t);
            const cosVal=Math.cos(t), sinVal=Math.sin(t);
            return (
              <g>
                {/* Hypotenuse r=1 */}
                <line x1={cx} y1={cy} x2={px} y2={py} stroke="#27ae60" strokeWidth="2.5"/>
                <text x={(cx+px)/2-10} y={(cy+py)/2-6} fontSize="10" fill="#27ae60" fontWeight="700">r=1</text>
                {/* cos side */}
                <line x1={cx} y1={cy} x2={cx+R*cosVal} y2={cy} stroke="#2E75B6" strokeWidth="2.5"/>
                <text x={cx+R*cosVal/2} y={cy+14} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">cos θ</text>
                {/* sin side */}
                <line x1={cx+R*cosVal} y1={cy} x2={px} y2={py} stroke="#c0392b" strokeWidth="2.5"/>
                <text x={px+14} y={(cy+py)/2+4} fontSize="11" fill="#c0392b" fontWeight="700">sin θ</text>
                {/* right angle box */}
                <polyline points={(cx+R*cosVal+10)+","+cy+" "+(cx+R*cosVal+10)+","+(cy-10)+" "+(cx+R*cosVal)+","+(cy-10)} fill="none" stroke="#555" strokeWidth="1.3"/>
                {/* Point */}
                <circle cx={px} cy={py} r={5} fill="#1F3864" stroke="#fff" strokeWidth="1.5"/>
                <text x={px+7} y={py-5} fontSize="11" fill="#1F3864" fontWeight="700">P(cos θ, sin θ)</text>
                {/* Angle arc */}
                <path d={"M "+(cx+30)+","+cy+" A 30 30 0 0 0 "+(cx+30*Math.cos(t))+","+(cy-30*Math.sin(t))} fill="none" stroke="#e07b00" strokeWidth="1.8"/>
                <text x={cx+34} y={cy-14} fontSize="11" fill="#e07b00" fontWeight="700">θ</text>
              </g>
            );
          })()}

          {/* Proof label */}
          <text x={cx} y={cy+R+32} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">cos² θ + sin² θ = r² = 1</text>

          {/* Identity family tree */}
          <rect x={360} y={10} width={524} height={278} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={622} y={32} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Pythagorean Identity Family</text>

          {/* Root identity */}
          <rect x={376} y={40} width={492} height={28} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
          <text x={622} y={58} textAnchor="middle" fontSize="13" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">sin² θ + cos² θ = 1</text>

          {/* Arrow down */}
          <line x1={622} y1={68} x2={622} y2={80} stroke="#bbb" strokeWidth="1.5"/>
          <text x={622} y={76} textAnchor="middle" fontSize="10" fill="#bbb">divide by cos²</text>

          {/* Tan identity */}
          <rect x={376} y={82} width={492} height={28} rx={4} fill="#fff7ee" stroke="#e07b00" strokeWidth="1.5"/>
          <text x={622} y={100} textAnchor="middle" fontSize="13" fill="#e07b00" fontFamily="'Courier New',monospace" fontWeight="700">tan² θ + 1 = sec² θ</text>

          <line x1={622} y1={110} x2={622} y2={122} stroke="#bbb" strokeWidth="1.5"/>
          <text x={376} y={118} fontSize="10" fill="#bbb">divide by sin²</text>

          {/* Cot identity */}
          <rect x={376} y={124} width={492} height={28} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
          <text x={622} y={142} textAnchor="middle" fontSize="13" fill="#27ae60" fontFamily="'Courier New',monospace" fontWeight="700">1 + cot² θ = csc² θ</text>

          {/* Divider */}
          <line x1={376} y1={162} x2={868} y2={162} stroke="#eee" strokeWidth="1"/>
          <text x={622} y={178} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">Reciprocal Identities</text>
          {[['csc θ = 1/sin θ','#c0392b'],['sec θ = 1/cos θ','#2E75B6'],['cot θ = 1/tan θ','#e07b00'],['tan θ = sin θ/cos θ','#555'],['cot θ = cos θ/sin θ','#555']].map(([eq,col],i)=>(
            <text key={i} x={382} y={196+i*18} fontSize="12" fill={col} fontFamily="'Courier New',monospace">{eq}</text>
          ))}

          <line x1={376} y1={286} x2={868} y2={286} stroke="#eee" strokeWidth="1"/>
        </svg>
      <div style={S.dCaption}>
        The single identity sin²θ + cos²θ = 1 comes directly from the Pythagorean theorem on the unit circle. Dividing by cos²θ gives the tan/sec version. Dividing by sin²θ gives the cot/csc version.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 6 — ME Applications
// ─────────────────────────────────────────────────────────────────
function DiagramMEApplications() {
  const W = 900, H = 300;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Trigonometry in Mechanical Engineering — Force Components, Inclines, and Torque</div>
        <svg viewBox={"0 0 "+W+" "+H} style={{width:'100%',display:'block'}}>

          {/* ── PANEL 1: Force decomposition ── */}
          <rect x={10} y={10} width={280} height={278} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={150} y={30} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Force Decomposition</text>
          {(() => {
            const bx=150, by=155, F=90, t=35*Math.PI/180;
            const Fx=F*Math.cos(t), Fy=F*Math.sin(t);
            return (
              <g>
                {/* Force vector */}
                <defs>
                  <marker id="fArr" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#1F3864"/></marker>
                  <marker id="fArrB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#2E75B6"/></marker>
                  <marker id="fArrR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#c0392b"/></marker>
                </defs>
                <line x1={bx} y1={by} x2={bx+F*Math.cos(t)} y2={by-F*Math.sin(t)} stroke="#1F3864" strokeWidth="2.5" markerEnd="url(#fArr)"/>
                <line x1={bx} y1={by} x2={bx+Fx} y2={by} stroke="#2E75B6" strokeWidth="2" strokeDasharray="4,3" markerEnd="url(#fArrB)"/>
                <line x1={bx+Fx} y1={by} x2={bx+Fx} y2={by-Fy} stroke="#c0392b" strokeWidth="2" strokeDasharray="4,3" markerEnd="url(#fArrR)"/>
                {/* Angle arc */}
                <path d={"M "+(bx+26)+","+by+" A 26 26 0 0 0 "+(bx+26*Math.cos(t))+","+(by-26*Math.sin(t))} fill="none" stroke="#e07b00" strokeWidth="1.5"/>
                <text x={bx+30} y={by-12} fontSize="12" fill="#e07b00" fontWeight="700">θ=35°</text>
                <text x={bx+F*Math.cos(t)+6} y={by-F*Math.sin(t)+4} fontSize="12" fill="#1F3864" fontWeight="700">F</text>
                <text x={bx+Fx/2} y={by+18} textAnchor="middle" fontSize="12" fill="#2E75B6">Fx=F·cos θ</text>
                <text x={bx+Fx+28} y={by-Fy/2} fontSize="12" fill="#c0392b">Fy=F·sin θ</text>
                {/* Axes */}
                <line x1={bx-60} y1={by} x2={bx+110} y2={by} stroke="#ddd" strokeWidth="1"/>
                <line x1={bx} y1={by+40} x2={bx} y2={by-110} stroke="#ddd" strokeWidth="1"/>
              </g>
            );
          })()}

          {/* ── PANEL 2: Inclined plane ── */}
          <rect x={305} y={10} width={280} height={278} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={445} y={30} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Inclined Plane Analysis</text>
          {(() => {
            const bx=308, by2=248, pw=260, t=25*Math.PI/180;
            const ph=pw*Math.tan(t);
            return (
              <g>
                {/* Incline triangle */}
                <polygon points={(bx+6)+","+(by2)+" "+(bx+pw)+","+(by2)+" "+(bx+pw)+","+(by2-ph)} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
                {/* Angle */}
                <path d={"M "+(bx+44)+","+by2+" A 38 38 0 0 0 "+(bx+6+38*Math.cos(t))+","+(by2-38*Math.sin(t))} fill="none" stroke="#e07b00" strokeWidth="1.5"/>
                <text x={bx+52} y={by2-12} fontSize="12" fill="#e07b00" fontWeight="700">α=25°</text>
                {/* Block */}
                {(() => {
                  const blx=bx+110, bly=by2-104*Math.tan(t);
                  const nx=-Math.sin(t), ny=-Math.cos(t);
                  return (
                    <g>
                      <rect x={blx-12} y={bly-14} width={24} height={16} fill="#e07b00" opacity="0.7" rx={2} transform={"rotate("+((-t*180/Math.PI).toFixed(1))+","+(blx)+","+(bly)+")"} />
                      {/* Weight down */}
                      <line x1={blx} y1={bly} x2={blx} y2={bly+44} stroke="#c0392b" strokeWidth="2" markerEnd="url(#fArrR)"/>
                      <text x={blx+5} y={bly+44} fontSize="11" fill="#c0392b">W=mg</text>
                      {/* Normal */}
                      <line x1={blx} y1={bly} x2={blx+nx*44} y2={bly+ny*44} stroke="#27ae60" strokeWidth="2" markerEnd="url(#fArrB)"/>
                      <text x={blx+nx*44+5} y={bly+ny*44} fontSize="11" fill="#27ae60">N</text>
                    </g>
                  );
                })()}
                <text x={445} y={by2+20} textAnchor="middle" fontSize="11" fill="#555">N = W·cos α</text>
                <text x={445} y={by2+36} textAnchor="middle" fontSize="11" fill="#555">F_parallel = W·sin α</text>
              </g>
            );
          })()}

          {/* ── PANEL 3: Torque / shaft ── */}
          <rect x={600} y={10} width={290} height={278} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={745} y={30} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Torque and Angle</text>
          {(() => {
            const cx2=745, cy2=145, r=70, t=50*Math.PI/180;
            const px=cx2+r*Math.cos(t), py=cy2-r*Math.sin(t);
            return (
              <g>
                {/* Shaft circle */}
                <circle cx={cx2} cy={cy2} r={r} fill="#f0f4ff" stroke="#2E75B6" strokeWidth="2"/>
                <circle cx={cx2} cy={cy2} r={8} fill="#2E75B6"/>
                {/* Radius arm */}
                <line x1={cx2} y1={cy2} x2={px} y2={py} stroke="#1F3864" strokeWidth="2.5"/>
                <text x={(cx2+px)/2-6} y={(cy2+py)/2+12} fontSize="10" fill="#1F3864" fontWeight="700">r</text>
                {/* Force perpendicular to radius */}
                {(() => {
                  const fx=-Math.sin(t)*40, fy=-Math.cos(t)*40;
                  return (
                    <g>
                      <line x1={px} y1={py} x2={px+fx} y2={py+fy} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#fArrR)"/>
                      <text x={px+fx+4} y={py+fy} fontSize="10" fill="#c0392b" fontWeight="700">F</text>
                    </g>
                  );
                })()}
                {/* Angle arc */}
                <path d={"M "+(cx2+24)+","+cy2+" A 24 24 0 0 0 "+(cx2+24*Math.cos(t))+","+(cy2-24*Math.sin(t))} fill="none" stroke="#e07b00" strokeWidth="1.5"/>
                <text x={cx2+28} y={cy2-12} fontSize="10" fill="#e07b00" fontWeight="700">θ</text>
                {/* Formulas */}
                <rect x={cx2-100} y={cy2+r+16} width={200} height={64} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
                <text x={cx2} y={cy2+r+32} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">T = r × F = r·F·sin θ</text>
                <text x={cx2} y={cy2+r+48} textAnchor="middle" fontSize="11" fill="#555">Max torque when θ=90°</text>
                <text x={cx2} y={cy2+r+64} textAnchor="middle" fontSize="11" fill="#555">sin(90°)=1 → T = r·F</text>
              </g>
            );
          })()}
        </svg>
      <div style={S.dCaption}>
        Three of the most common trig applications in ME. Force decomposition: break any force into orthogonal components using cos (along axis) and sin (perpendicular). Inclined plane: normal force uses cos of slope angle. Torque: the cross product magnitude is r·F·sinθ.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────
export default function Trigonometry(props) {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Trigonometry</h1>

      <p style={S.p}>
        Trigonometry is the mathematics of angles and the ratios between sides of triangles. In engineering it is used every time a force, velocity, or displacement has a direction — which is nearly always. Force decomposition, inclined planes, rotating machinery, vibrations, and wave analysis all rely on trig directly.
      </p>

      <InfoBox
        title="The Six Trig Functions — All Defined as Ratios of Triangle Sides"
        items={[
          "sin θ = opposite / hypotenuse      csc θ = hypotenuse / opposite  (= 1/sin θ)",
          "cos θ = adjacent / hypotenuse      sec θ = hypotenuse / adjacent  (= 1/cos θ)",
          "tan θ = opposite / adjacent        cot θ = adjacent / opposite    (= 1/tan θ = cos/sin)",
          "Pythagorean theorem: opposite² + adjacent² = hypotenuse²",
        ]}
      />

      <h2 style={S.h2}>Right Triangle — All Six Ratios</h2>
      <DiagramRightTriangle />
      <Table2 rows={[
        ["sin θ",           "opposite / hypotenuse\nVertical component of a unit vector at angle θ"],
        ["cos θ",           "adjacent / hypotenuse\nHorizontal component of a unit vector at angle θ"],
        ["tan θ",           "opposite / adjacent = sin θ / cos θ\nSlope of the hypotenuse — rise over run"],
        ["csc θ",           "1 / sin θ = hypotenuse / opposite"],
        ["sec θ",           "1 / cos θ = hypotenuse / adjacent"],
        ["cot θ",           "1 / tan θ = adjacent / opposite = cos θ / sin θ"],
        ["Special angles",  "θ=30°: sin=1/2, cos=√3/2, tan=1/√3\nθ=45°: sin=cos=√2/2, tan=1\nθ=60°: sin=√3/2, cos=1/2, tan=√3"],
        ["Inverse trig",    "arcsin, arccos, arctan — find the angle given a ratio\narctan(opp/adj) = angle  (use atan2 for correct quadrant)"],
      ]} />

      <h2 style={S.h2}>The Unit Circle</h2>
      <DiagramUnitCircle />
      <Table2 rows={[
        ["Unit circle",     "Circle of radius 1 centered at origin\nAny point on it is (cos θ, sin θ) for angle θ"],
        ["Extending beyond 90°","Unit circle extends trig to all angles, not just 0-90°\nSigns of sin and cos change by quadrant"],
        ["Quadrant signs",  "Q1 (0-90°):   sin+, cos+\nQ2 (90-180°): sin+, cos-\nQ3 (180-270°):sin-, cos-\nQ4 (270-360°):sin-, cos+\nMemonic: All Students Take Calculus (ASTC)"],
        ["Radians",         "π radians = 180°.  1 radian ≈ 57.3°\nConvert: degrees × π/180 = radians\nConvert: radians × 180/π = degrees"],
        ["Common values",   "sin(0)=0, sin(π/6)=0.5, sin(π/4)=√2/2, sin(π/3)=√3/2, sin(π/2)=1\ncos mirrors sin shifted by π/2"],
      ]} />

      <h2 style={S.h2}>SOH-CAH-TOA</h2>
      <DiagramSOHCAHTOA />
      <Table2 rows={[
        ["SOH",             "Sin = Opposite / Hypotenuse\nUse when: you know hyp and want the vertical (perpendicular) component"],
        ["CAH",             "Cos = Adjacent / Hypotenuse\nUse when: you know hyp and want the horizontal (parallel) component"],
        ["TOA",             "Tan = Opposite / Adjacent\nUse when: you know both legs and want the angle, or know angle and one leg"],
        ["Finding the angle","θ = arctan(opp/adj) — most common in ME\nθ = arcsin(opp/hyp) or arccos(adj/hyp) also work\nUse atan2(y,x) in calculators/code for correct quadrant"],
        ["Force components","F_x = F·cos θ  (component along x-axis)\nF_y = F·sin θ  (component along y-axis)\nResultant: F = √(F_x² + F_y²),  θ = atan2(F_y, F_x)"],
      ]} />

      <h2 style={S.h2}>Trigonometric Graphs</h2>
      <DiagramTrigGraphs />
      <Table2 rows={[
        ["General sinusoid","y = A·sin(Bx + C) + D\nA = amplitude, B = frequency multiplier, C = phase shift, D = vertical shift"],
        ["Period",          "sin and cos: T = 2π/B\ntan and cot: T = π/B"],
        ["Amplitude",       "A — half the distance from min to max\nsin and cos naturally have amplitude 1; tan has no amplitude"],
        ["Phase shift",     "-C/B — horizontal shift of the whole wave\nPositive C shifts left, negative C shifts right"],
        ["sin vs cos",      "cos(x) = sin(x + π/2) — cosine leads sine by 90°\nIn vibrations: position is sin, velocity leads by 90°"],
        ["tan asymptotes",  "Vertical asymptotes at x = π/2 + nπ where cos = 0\ntan is undefined at these points"],
      ]} />

      <h2 style={S.h2}>Pythagorean Identities</h2>
      <DiagramIdentities />
      <Table2 rows={[
        ["Primary identity",    "sin²θ + cos²θ = 1\nTrue for all angles — comes directly from Pythagorean theorem on unit circle"],
        ["Tan/sec form",        "tan²θ + 1 = sec²θ\nDerived by dividing primary identity by cos²θ"],
        ["Cot/csc form",        "1 + cot²θ = csc²θ\nDerived by dividing primary identity by sin²θ"],
        ["Double angle",        "sin(2θ) = 2·sin θ·cos θ\ncos(2θ) = cos²θ - sin²θ = 1 - 2sin²θ = 2cos²θ - 1"],
        ["Sum of angles",       "sin(A±B) = sinA·cosB ± cosA·sinB\ncos(A±B) = cosA·cosB ∓ sinA·sinB"],
        ["Half angle",          "sin²θ = (1 - cos 2θ)/2\ncos²θ = (1 + cos 2θ)/2\nUsed to simplify integrals of sin² and cos²"],
      ]} />

      <h2 style={S.h2}>Mechanical Engineering Applications</h2>
      <DiagramMEApplications />

      <InfoBox
        title="Key Takeaway — Trig Is the Language of Directions and Angles"
        items={[
          "Force decomposition: F_x = F·cosθ, F_y = F·sinθ — used in every statics and dynamics problem.",
          "Inclined plane: normal force N = W·cosα, parallel component = W·sinα.",
          "Torque: T = r·F·sinθ — maximum when force is perpendicular to the moment arm (θ=90°).",
          "Rotating machinery: angular position θ(t) = ωt, with sin/cos describing x and y projections.",
          "Vibrations: x(t) = A·sin(ωₙt + φ) — amplitude A, natural frequency ωₙ, phase φ.",
          "Law of cosines: c² = a² + b² - 2ab·cosC — used for non-right triangles in force polygons.",
          "Law of sines: a/sinA = b/sinB = c/sinC — used when you know an angle-side pair.",
        ]}
      />
    </div>
  );
}